<div class="config-card" [ngStyle]="{ width: width, height: height }">
  <div class="d-flex align-items-center p-3">
    <mat-icon class="material-symbols-outlined text-ligth-grey">{{ icon }}</mat-icon>
    <p class="config-card__title ml-2 mb-0">{{ title }}</p>
  </div>
  <hr class="w-100 my-0" />
  <div class="px-4 py-3 h-100">
    @if (cardState === 'loading') {
      <ngx-skeleton-loader
        [theme]="{ width: '80%', height: '25px', borderRadius: '16px', background: 'var(--empty-background)' }"
      ></ngx-skeleton-loader>
      <div *forCount="3" style="width: 100%">
        <ngx-skeleton-loader
          [theme]="{ width: '60%', height: '25px', borderRadius: '16px', background: 'var(--empty-background)' }"
        ></ngx-skeleton-loader>
      </div>
    } @else {
      <ng-content></ng-content>
    }
  </div>
  @if (showButtons) {
    @if (cardState === 'view' && canEdit) {
      <div class="d-flex m-3 mt-auto">
        <button class="config-card__edit-button ml-auto" (click)="onButtonActionClick('onEdit')">Edit</button>
      </div>
    }
    @if (cardState === 'edit' || cardState === 'saving') {
      <div class="d-flex m-3 mt-auto">
        @if (!showConfirmationDialog) {
          <button type="button" class="config-card__cancel-button ml-auto" (click)="onButtonActionClick('onCancel')">
            Cancel
          </button>
        }
        @if (!showConfirmationDialog) {
          <button
            class="config-card__save-button ml-2"
            [class.disabled]="isSaveDisabled || cardState === 'saving'"
            [disabled]="isSaveDisabled || cardState === 'saving'"
            (click)="onButtonActionClick('onSave')"
          >
            @if (cardState === 'saving') {
              <mat-spinner style="display: inline-block" [diameter]="16" [strokeWidth]="3"></mat-spinner>
            }
            Save
          </button>
        }
        @if (showConfirmationDialog) {
          <button
            [class.disabled]="isSaveDisabled || cardState === 'saving'"
            [disabled]="cardState === 'saving' || isSaveDisabled"
            class="config-card__save-button ml-auto px-3"
            style="width: 130px"
            [matTooltip]="isSaveDisabled && errorMessage ? errorMessage : ''"
            (click)="triggerDialog()"
          >
            @if (cardState === 'saving') {
              <mat-spinner style="display: inline-block" [diameter]="16" [strokeWidth]="3"></mat-spinner>
            }
            Update...
          </button>
        }
      </div>
    }
  }
</div>
